import React, { forwardRef } from 'react';
import './Banner.css';

const Banner = forwardRef(({ backgroundImage, _parentClass, _containerClass, children }, ref) => {
  return (
    <section
      ref={ref}
      className={`w-full ${_parentClass}`}
      style={{ backgroundImage: `url(${backgroundImage})`}} 
      data-aos-offset="500"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">  
    
      <div className="container">
        <div className="row">
          {children}
        </div>
      </div>
    </section>
  );
});

export default Banner;
